import { useEffect, useContext, useState } from "react";
import { useUserAuth } from "../context/UserAuthContext";
import { MyContext } from "./Structure";

const FreeCard = ({ isCollapsed }) => {
  const { user } = useUserAuth();
  const {calculateTotalFileSize  ,totalSizePercent} = useContext(MyContext);

  const [loading, setloading] = useState(false);
 
  const calculate = () =>{
    if (!user?.email) return;

    setloading(true)
    try{
      calculateTotalFileSize();
    }
    catch(err){
      console.log(err);
    }
    finally{
      setloading(false)
    }
    
  }
  
  useEffect(() => {
    calculate()
  }, [user?.email])
  return (
    <div className="w-full flex flex-col items-center">
      {!loading ?
        <div className={`w-full flex bg-white flex-col shadow-lg rounded-2xl transition-all duration-300 ${
          isCollapsed ? 'py-3 px-2 items-center' : 'py-4 px-3 items-start border border-gray-100'
        }`}>
          {!isCollapsed ? (
            <>
              <div className="flex items-center gap-2 mb-3 w-full px-2">
                {user.emailVerified && <img src={require('../assert/verified.png')} alt="verified" className="w-5 h-5 shrink-0" />}
                <h1 className="text-sm font-bold text-slate-700 truncate capitalize">
                  {user?.displayName || user?.email?.split('@')[0]}
                </h1>
              </div>

              <div className="w-full border-t border-gray-100 pt-4 flex flex-col gap-2">
                <div className="flex justify-between items-center text-[11px] font-bold text-slate-500 uppercase tracking-wider">
                  <span>Storage</span>
                  <span className="text-blue-600">{`${totalSizePercent.toFixed(1)}%`}</span>
                </div>
                <div className="w-full bg-gray-100 rounded-full h-2 overflow-hidden shadow-inner">
                  <div 
                    className="bg-gradient-to-r from-blue-500 to-indigo-600 h-full rounded-full transition-all duration-500 ease-out" 
                    style={{ width: `${totalSizePercent}%` }}
                  ></div>
                </div>
              </div>
            </>
          ) : (
            <div className="flex flex-col items-center gap-2" title={`${totalSizePercent.toFixed(1)}% Storage Used`}>
              <div className="relative w-10 h-10 flex items-center justify-center">
                 <svg className="w-full h-full transform -rotate-90">
                    <circle
                      cx="20"
                      cy="20"
                      r="16"
                      stroke="#f3f4f6"
                      strokeWidth="4"
                      fill="transparent"
                    />
                    <circle
                      cx="20"
                      cy="20"
                      r="16"
                      stroke="#3b82f6"
                      strokeWidth="4"
                      fill="transparent"
                      strokeDasharray="100.53"
                      strokeDashoffset={100.53 - (totalSizePercent * 100.53 / 100)}
                      className="transition-all duration-500 ease-out"
                    />
                 </svg>
                 <span className="absolute text-[8px] font-bold text-slate-700">{Math.round(totalSizePercent)}%</span>
              </div>
            </div>
          )}
        </div> :
        <div className={`bg-white shadow-sm rounded-2xl w-full animate-pulse border border-gray-100 ${isCollapsed ? 'p-2' : 'p-4'}`}>
          <div className="flex items-center space-x-3 mb-4">
            <div className="rounded-full bg-gray-200 h-8 w-8 shrink-0"></div>
            {!isCollapsed && <div className="h-4 bg-gray-200 rounded w-24"></div>}
          </div>
          <div className="space-y-3">
            <div className="h-2 bg-gray-100 rounded w-full"></div>
          </div>
        </div>
      }
    </div>
  );
};

export default FreeCard;